import React from 'react';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import {Link} from 'react-router-dom';

const ProblemDetailsBreadcrumb = ({data}) => {
    if(data !== null){
        if(data.topicId !== 'null'){
            let courseUrl = "/" + data.userPrefix + "/courses/" + data.courseId;
            let topicUrl = courseUrl + "/topic/" + data.topicId;

            return (
                <Breadcrumb>
                    <BreadcrumbItem> <Link to={courseUrl}>{data.courseName}</Link> </BreadcrumbItem>
                    <BreadcrumbItem> <Link to={topicUrl}>{data.topicName}</Link> </BreadcrumbItem>
                    <BreadcrumbItem active>{data.problemName}</BreadcrumbItem>
                </Breadcrumb>
            );
        }
        else{
            let algorithmsUrl = "/algorithms"
            return(
                <Breadcrumb>
                    <BreadcrumbItem> <Link to={algorithmsUrl}>Algoritamski zadaci</Link> </BreadcrumbItem>
                    <BreadcrumbItem active>{data.problemName}</BreadcrumbItem>
                </Breadcrumb>
            );
        }
    }
    else
        return <div></div>
};

export default ProblemDetailsBreadcrumb;
